export default theme => ({
  root: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  }
});
